module.exports = __webpack_public_path__ + "img/cross.0d5eb4c1.svg";